import http from "@/settings/apiSettings"

class StudiesDataService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post('/PER_Studies', data)
    }
}
export default new StudiesDataService()